import { useCallback } from 'react';
import toast from 'react-hot-toast';
import { trackEvent } from 'helpers/analytics';
import {
  useGetSignupFormQuery,
  useCreateSignupFormMutation,
  useSetSignupFormActiveMutation,
} from '../../../../services/signupForms';

export function useSignupForm({ collectionId, sharedListId }) {
  const {
    data: formConfig,
    isLoading: isLoadingForm,
    error,
  } = useGetSignupFormQuery({ collectionId, sharedListId }, { skip: !collectionId || !sharedListId });

  const [createSignupForm, { isLoading: isCreating }] = useCreateSignupFormMutation();
  const [setSignupFormActive, { isLoading: isEnabling }] = useSetSignupFormActiveMutation();

  const hasExistingInactiveForm = formConfig?.id && formConfig?.active === false;
  const isFormActive = formConfig?.active === true;

  const handleEnableSignupForm = useCallback(async () => {
    try {
      if (hasExistingInactiveForm) {
        await setSignupFormActive({
          collectionId,
          sharedListId,
          formId: formConfig.id,
          active: true,
        }).unwrap();
      } else {
        await createSignupForm({
          collectionId,
          sharedListId,
        }).unwrap();
      }
      trackEvent('contacts:list:enable_signup_form', {
        collection_id: collectionId,
        list_id: sharedListId,
      });
    } catch (err) {
      toast.error('Failed to enable signup form. Please try again.');
    }
  }, [hasExistingInactiveForm, setSignupFormActive, createSignupForm, collectionId, sharedListId, formConfig?.id]);

  return {
    formConfig,
    isLoadingForm,
    isCreating: isCreating || isEnabling,
    error,
    isFormActive,
    handleEnableSignupForm,
  };
}
